import { render } from "./ResourcesUpload.vue?vue&type=template&id=1d8632e7&scoped=true"
import script from "./ResourcesUpload.vue?vue&type=script&lang=js"
export * from "./ResourcesUpload.vue?vue&type=script&lang=js"

import "./ResourcesUpload.vue?vue&type=style&index=0&id=1d8632e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8632e7"]])

export default __exports__